import type { Actor, AnyActorLogic } from 'xstate';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';

export class GenericActorStore<TLogic extends AnyActorLogic> extends WeakMap<
	EditorView,
	Actor<TLogic>
> {
	getActor(editorView: EditorView) {
		if (this.has(editorView)) {
			return this.get(editorView);
		}
		return null;
	}

	setActor(editorView: EditorView, actorRef: Actor<TLogic>): void {
		this.set(editorView, actorRef);
	}
}
